module.exports = __webpack_public_path__ + "assets/path-3-719d6284a343bed84c803a269656d94b.svg";